import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  measurer: {
    position: 'absolute',
    left: 0,
    right: 0,
    opacity: 0,
    zIndex: -1,
  },
});
